import type { ChangedPlanRecord } from "./types"
import { createTreeState } from "components/TreeState"

export const flowPlanItemsState = createTreeState<ChangedPlanRecord>({
  getKey: (it) => it.id!,
  getParentKey: (it) => it.parentId,
  setOrder: (it, order) => {
    if (!!it) {
      it.orderId = order
      if (!it.action) {
        it.action = "UPDATE_ORDER"
      }
    }
  },
  compare: (a, b) => {
    const oa = a?.orderId ?? 0
    const ob = b?.orderId ?? 0
    if (oa > ob) return 1
    if (oa < ob) return -1
    else return 0
  },
  mergeParentProperties: (values, parentValues) => {
    return {
      ...values,
      mediaColor: values?.mediaColor || parentValues?.mediaColor,
    }
  },
  isNew: (values) => ["CREATE", "CREATE_NESTED"].includes(values?.action || ""),
})

export const crPlanItemsState = createTreeState<ChangedPlanRecord>({
  getKey: (it) => it.id!,
  getParentKey: (it) => it.parentId,
  setOrder: (it, order) => {
    if (!!it) {
      it.orderId = order
      if (!it.action) {
        it.action = "UPDATE_ORDER"
      }
    }
  },
  compare: (a, b) => {
    const oa = a?.orderId ?? 0
    const ob = b?.orderId ?? 0
    if (oa > ob) return 1
    if (oa < ob) return -1
    else return 0
  },
  mergeParentProperties: (values, parentValues) => {
    return {
      ...values,
      mediaColor: values?.mediaColor || parentValues?.mediaColor,
    }
  },
  isNew: (values) => ["CREATE", "CREATE_NESTED"].includes(values?.action || ""),
})

export const bookingItemsState = createTreeState<ChangedPlanRecord>({
  getKey: (it) => it.id!,
  getParentKey: (it) => it.parentId,
  setOrder: (it, order) => {
    if (!!it) {
      it.orderId = order
      if (!it.action) {
        it.action = "UPDATE_ORDER"
      }
    }
  },
  compare: (a, b) => {
    const oa = a?.orderId ?? 0
    const ob = b?.orderId ?? 0
    if (oa > ob) return 1
    if (oa < ob) return -1
    else return 0
  },
  mergeParentProperties: (values, parentValues) => {
    return {
      ...values,
      mediaColor: values?.mediaColor || parentValues?.mediaColor,
    }
  },
  isNew: (values) => ["CREATE", "CREATE_NESTED"].includes(values?.action || ""),
})

export const revBookingItemsState = createTreeState<ChangedPlanRecord>({
  getKey: (it) => it.id!,
  getParentKey: (it) => it.parentId,
  setOrder: (it, order) => {
    if (!!it) {
      it.orderId = order
      if (!it.action) {
        it.action = "UPDATE_ORDER"
      }
    }
  },
  compare: (a, b) => {
    const oa = a?.orderId ?? 0
    const ob = b?.orderId ?? 0
    if (oa > ob) return 1
    if (oa < ob) return -1
    else return 0
  },
  mergeParentProperties: (values, parentValues) => {
    return {
      ...values,
      mediaColor: values?.mediaColor || parentValues?.mediaColor,
    }
  },
  isNew: (values) =>
    ["CREATE", "CREATE_NESTED", "SPLIT"].includes(values?.action || ""),
})
